import { InjectionToken } from '@angular/core';

import {
  type INavbarConfig,
  type INavbarResponsiveLayout,
} from '../navbar.interfaces';

export const NAVBAR_CONFIG = new InjectionToken('NavbarConfig');
export const NAVBAR_USER_CONFIG = new InjectionToken('NavbarUserConfig');

export class NavbarConfig implements INavbarConfig {
  public layout: INavbarResponsiveLayout = {
    d: {
      left: [4],
      center: [4],
      right: [4],
    },
    t: {
      left: [3],
      center: [2],
      right: [3],
    },
    p: {
      left: [1],
      center: [2],
      right: [1],
    },
  };
}

const NAVBAR_CONFIG_PROVIDER = {
  provide: NAVBAR_CONFIG,
  useValue: new NavbarConfig(),
};
